import { z } from 'zod';

export const HR_TALENT_ROLE = 'hr_talent';

export const organizationManagementOptionsSchema = z.object({
    assignableRoles: z.array(z.string()).default([]),
    canManagePositionAccess: z.boolean().default(false),
    invitableRoles: z.array(z.string()).default([]),
});

export type OrganizationManagementOptions = z.infer<typeof organizationManagementOptionsSchema>;
